import React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import { noteRound } from "../../../util/DoubleUtil";


export default function RelatorioAtaFinalNotaBimestreWeb({ ataFinal }) {

    return (
        <>
            <Typography
                style={{
                    textAlign: 'center',
                    textDecoration: 'underline'
                }}
                variant="h6">
                Base Comum
            </Typography>
            <Table size="small" aria-label="a dense table">
                <TableHead>
                    <TableRow>
                        <TableCell rowSpan={2}>Disciplinas</TableCell>
                        <TableCell colSpan={4} sx={{ textAlign: 'center' }}>Média Bimestral</TableCell>
                        <TableCell rowSpan={2}>5º Conceito</TableCell>
                        <TableCell rowSpan={2}>Média Final</TableCell>
                        <TableCell rowSpan={2}>Total Aulas</TableCell>
                        <TableCell rowSpan={2}>Total Faltas</TableCell>
                        <TableCell rowSpan={2}>Freq.(%)</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>1º</TableCell>
                        <TableCell>2º</TableCell>
                        <TableCell>3º</TableCell>
                        <TableCell>4º</TableCell>
                    </TableRow>
                </TableHead>

                <TableBody>
                    {ataFinal.map((af, index) => (
                        <TableRow key={index}>
                            <TableCell>{af.tdp.disciplina.descricao}</TableCell>
                            <TableCell>{af.mediaBimestral1 && af.mediaBimestral1.nota ? noteRound(af.mediaBimestral1.nota) : '--'}</TableCell>
                            <TableCell>{af.mediaBimestral2 && af.mediaBimestral2.nota ? noteRound(af.mediaBimestral2.nota) : '--'}</TableCell>
                            <TableCell>{af.mediaBimestral3 && af.mediaBimestral3.nota ? noteRound(af.mediaBimestral3.nota) : '--'}</TableCell>
                            <TableCell>{af.mediaBimestral4 && af.mediaBimestral4.nota ? noteRound(af.mediaBimestral4.nota) : '--'}</TableCell>
                            <TableCell>{af.quintoConceito && af.quintoConceito.nota ? noteRound(af.quintoConceito.nota) : '--'}</TableCell>
                            <TableCell>{af.mediaFinal && af.mediaFinal.nota ? noteRound(af.mediaFinal.nota) : '--'}</TableCell>
                            <TableCell>{af.totalAulas ? af.totalAulas : '--'}</TableCell>
                            <TableCell>{af.totalFaltas ? af.totalFaltas : '--'}</TableCell>
                            <TableCell>{af.frequencia ? af.frequencia : '--'}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </>
    );
}